import { render, staticRenderFns } from "./FluHistoryTable.vue?vue&type=template&id=ff31dafe&scoped=true"
import script from "./FluHistoryTable.vue?vue&type=script&lang=js"
export * from "./FluHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./FluHistoryTable.vue?vue&type=style&index=0&id=ff31dafe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff31dafe",
  null
  
)

export default component.exports